import { GQLSex, GQLAcquisitionFrom, GQLChueiBankMemberType, GQLKyofukuMemberType, GQLPaymentMethod, GQLPrefecture, GQLTestType } from '../generated/graphql'


export function createEnumComverter<T, K>(map: Map<T, K>): (value: T) => K{
  return value => {
    return map.get(value)!
  }
}

export const sexConverter = createEnumComverter(new Map([
  [0, GQLSex.Male],
  [1, GQLSex.Female]
]))

export const acquisitionFromConverter = createEnumComverter(new Map([
  [0, GQLAcquisitionFrom.OtherAd],
  [1, GQLAcquisitionFrom.Introduce],
  [2, GQLAcquisitionFrom.WebAd],
  [3, GQLAcquisitionFrom.Media],
  [4, GQLAcquisitionFrom.PaperAd],
  [5, GQLAcquisitionFrom.WebSite],
  [6, GQLAcquisitionFrom.RadioOrTvOrYoutube],
  [7, GQLAcquisitionFrom.WebSearch],
  [8, GQLAcquisitionFrom.Other],
  [9, GQLAcquisitionFrom.HospitalOrClinic],
  [10, GQLAcquisitionFrom.MailFromRenatech],
  [11, GQLAcquisitionFrom.EmailFromRenatech]
]))

export const chueiBankMemberTypeConverter = createEnumComverter(new Map([
  [0, GQLChueiBankMemberType.Nenkin],
  [1, GQLChueiBankMemberType.Syokuiki]
]))

export const kyofukuMemberTypeConverter = createEnumComverter(new Map([
  [0, GQLKyofukuMemberType.Current],
  [1, GQLKyofukuMemberType.Continuation],
  [2, GQLKyofukuMemberType.Companion],
  [3, GQLKyofukuMemberType.Current2]
]))

export const paymentMethodConverter = createEnumComverter(new Map([
  [0, GQLPaymentMethod.Debit],
  [1, GQLPaymentMethod.Credit]
]))

export const prefectureLabelMap = new Map([
  ['北海道', GQLPrefecture.Hokkaido],
  ['青森県', GQLPrefecture.Aomori],
  ['岩手県', GQLPrefecture.Iwate],
  ['宮城県', GQLPrefecture.Miyagi],
  ['秋田県', GQLPrefecture.Akita],
  ['山形県', GQLPrefecture.Yamagata],
  ['福島県', GQLPrefecture.Fukushima],
  ['茨城県', GQLPrefecture.Ibaraki],
  ['栃木県', GQLPrefecture.Tochigi],
  ['群馬県', GQLPrefecture.Gumma],
  ['埼玉県', GQLPrefecture.Saitama],
  ['千葉県', GQLPrefecture.Chiba],
  ['東京都', GQLPrefecture.Tokyo],
  ['神奈川県', GQLPrefecture.Kanagawa],
  ['新潟県', GQLPrefecture.Niigata],
  ['富山県', GQLPrefecture.Toyama],
  ['石川県', GQLPrefecture.Ishikawa],
  ['福井県', GQLPrefecture.Fukui],
  ['山梨県', GQLPrefecture.Yamanashi],
  ['長野県', GQLPrefecture.Nagano],
  ['岐阜県', GQLPrefecture.Gifu],
  ['静岡県', GQLPrefecture.Shizuoka],
  ['愛知県', GQLPrefecture.Aichi],
  ['三重県', GQLPrefecture.Mie],
  ['滋賀県', GQLPrefecture.Shiga],
  ['京都府', GQLPrefecture.Kyoto],
  ['大阪府', GQLPrefecture.Osaka],
  ['兵庫県', GQLPrefecture.Hyogo],
  ['奈良県', GQLPrefecture.Nara],
  ['和歌山県', GQLPrefecture.Wakayama],
  ['鳥取県', GQLPrefecture.Tottori],
  ['島根県', GQLPrefecture.Shimane],
  ['岡山県', GQLPrefecture.Okayama],
  ['広島県', GQLPrefecture.Hiroshima],
  ['山口県', GQLPrefecture.Yamaguchi],
  ['徳島県', GQLPrefecture.Tokushima],
  ['香川県', GQLPrefecture.Kagawa],
  ['愛媛県', GQLPrefecture.Ehime],
  ['高知県', GQLPrefecture.Kochi],
  ['福岡県', GQLPrefecture.Fukuoka],
  ['佐賀県', GQLPrefecture.Saga],
  ['長崎県', GQLPrefecture.Nagasaki],
  ['熊本県', GQLPrefecture.Kumamoto],
  ['大分県', GQLPrefecture.Oita],
  ['宮崎県', GQLPrefecture.Miyazaki],
  ['鹿児島県', GQLPrefecture.Kagoshima],
  ['沖縄県', GQLPrefecture.Okinawa]
])

export const prefectureConverter = createEnumComverter(prefectureLabelMap)

export const testTypeConverter = (type: number, course?: number): GQLTestType => {
  switch(type){
    case 0:
      return GQLTestType.MbClub
    case 1:
      switch(course){
        case 0:
          return GQLTestType.OldTriallMb
        case 1:
          return GQLTestType.OldStandardMb
        case 3:
          return GQLTestType.OldTrialMbWithCohort
        case 4:
          return GQLTestType.StandardFree
        case 5:
          return GQLTestType.StandardFreeLp
      }
    case 2:
      return GQLTestType.StandardMb
    case 3:
      return GQLTestType.Kyofuku
    case 4:
      return GQLTestType.ChueiBank
    case 5:
      return GQLTestType.Riebe
    case 6:
      return GQLTestType.Promotion
    case 7:
      return GQLTestType.SapporoChusho
    case 8:
      switch(course){
        case 4:
          return GQLTestType.BohseiMb
        case 5:
          return GQLTestType.BohseiFree
      }
    case 9:
      return GQLTestType.Insurance
    case 10:
      return GQLTestType.Genovision
    case 11:
      return GQLTestType.ReloClub
    case 12:
      return GQLTestType.Benefit
    case 13:
      return GQLTestType.GoldenLoop
    case 14:
      return GQLTestType.Coupon
    default:
      throw new Error('Test type not match.')
  }
} 